// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-module--footer--3t1O2","links":"footer-module--links--v3q5l","icons":"footer-module--icons--252r8","copyright":"footer-module--copyright--1KdW6"};